export default __webpack_public_path__ + "assets/56df272fb2f1d8eb39f4439178333a92.png";